import {
  Companion_getInstance2j3pmvyptu679 as Companion_getInstance,
  ExternalAsyncTaskRequestlkl21m26cexi as ExternalAsyncTaskRequest,
} from './ExternalAsyncTaskRequest.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Instant3cn81rq2kpflk as Instant,
  Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_0,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { System_instance3dr57gee6r420 as System_instance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Clock.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareExternalAsyncTaskRequestFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ExternalAsyncTaskRequest__id_getInstance(), ExternalAsyncTaskRequest_ourData_getInstance(), ExternalAsyncTaskRequest_expiresAt_getInstance(), ExternalAsyncTaskRequest_createdAt_getInstance(), ExternalAsyncTaskRequest_response_getInstance(), ExternalAsyncTaskRequest_result_getInstance(), ExternalAsyncTaskRequest_action_getInstance(), ExternalAsyncTaskRequest_lastAttempt_getInstance(), ExternalAsyncTaskRequest_processingError_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function ExternalAsyncTaskRequest__id$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function ExternalAsyncTaskRequest__id$_get_name_$ref_9zm48v() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest__id$_get_serializer_$ref_vpscyg() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest__id$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function ExternalAsyncTaskRequest__id$_get_annotations_$ref_rbuoic() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest__idClass;
function ExternalAsyncTaskRequest__id() {
  if (ExternalAsyncTaskRequest__idClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest__id_instance = this;
        var tmp = this;
        tmp.x33_1 = lazy(ExternalAsyncTaskRequest__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.y33_1 = lazy(ExternalAsyncTaskRequest__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.z33_1 = lazy(ExternalAsyncTaskRequest__id$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.x33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest__id$_get_name_$ref_9zm48v(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.b34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      k34(receiver, value) {
        return receiver.l34(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.k34(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.y33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest__id$_get_serializer_$ref_vpscyg(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.z33_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest__id$_get_annotations_$ref_rbuoic(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest__id', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest__idClass = $;
  }
  return ExternalAsyncTaskRequest__idClass;
}
var ExternalAsyncTaskRequest__id_instance;
function ExternalAsyncTaskRequest__id_getInstance() {
  if (ExternalAsyncTaskRequest__id_instance === VOID)
    new (ExternalAsyncTaskRequest__id())();
  return ExternalAsyncTaskRequest__id_instance;
}
function ExternalAsyncTaskRequest_ourData$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function ExternalAsyncTaskRequest_ourData$_get_name_$ref_gd3oil() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_ourData$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_ourData$_get_serializer_$ref_apf804() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_ourData$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function ExternalAsyncTaskRequest_ourData$_get_annotations_$ref_75rb9k() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_ourDataClass;
function ExternalAsyncTaskRequest_ourData() {
  if (ExternalAsyncTaskRequest_ourDataClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_ourData_instance = this;
        var tmp = this;
        tmp.m34_1 = lazy(ExternalAsyncTaskRequest_ourData$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n34_1 = lazy(ExternalAsyncTaskRequest_ourData$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o34_1 = lazy(ExternalAsyncTaskRequest_ourData$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.m34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_ourData$_get_name_$ref_gd3oil(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.c34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      k34(receiver, value) {
        return receiver.l34(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.k34(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.n34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_ourData$_get_serializer_$ref_apf804(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_ourData$_get_annotations_$ref_75rb9k(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_ourData', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_ourDataClass = $;
  }
  return ExternalAsyncTaskRequest_ourDataClass;
}
var ExternalAsyncTaskRequest_ourData_instance;
function ExternalAsyncTaskRequest_ourData_getInstance() {
  if (ExternalAsyncTaskRequest_ourData_instance === VOID)
    new (ExternalAsyncTaskRequest_ourData())();
  return ExternalAsyncTaskRequest_ourData_instance;
}
function ExternalAsyncTaskRequest_expiresAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function ExternalAsyncTaskRequest_expiresAt$_get_name_$ref_8xywoe() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_expiresAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_expiresAt$_get_serializer_$ref_gw5k7p() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_expiresAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function ExternalAsyncTaskRequest_expiresAt$_get_annotations_$ref_sgeynt() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_expiresAtClass;
function ExternalAsyncTaskRequest_expiresAt() {
  if (ExternalAsyncTaskRequest_expiresAtClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_expiresAt_instance = this;
        var tmp = this;
        tmp.p34_1 = lazy(ExternalAsyncTaskRequest_expiresAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.q34_1 = lazy(ExternalAsyncTaskRequest_expiresAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.r34_1 = lazy(ExternalAsyncTaskRequest_expiresAt$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.p34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_expiresAt$_get_name_$ref_8xywoe(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.d34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      s34(receiver, value) {
        return receiver.l34(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.s34(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.q34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_expiresAt$_get_serializer_$ref_gw5k7p(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.r34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_expiresAt$_get_annotations_$ref_sgeynt(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_expiresAt', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_expiresAtClass = $;
  }
  return ExternalAsyncTaskRequest_expiresAtClass;
}
var ExternalAsyncTaskRequest_expiresAt_instance;
function ExternalAsyncTaskRequest_expiresAt_getInstance() {
  if (ExternalAsyncTaskRequest_expiresAt_instance === VOID)
    new (ExternalAsyncTaskRequest_expiresAt())();
  return ExternalAsyncTaskRequest_expiresAt_instance;
}
function ExternalAsyncTaskRequest_createdAt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function ExternalAsyncTaskRequest_createdAt$_get_name_$ref_k7044e() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_createdAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_createdAt$_get_serializer_$ref_77uhmx() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_createdAt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function ExternalAsyncTaskRequest_createdAt$_get_annotations_$ref_qrm3bn() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_createdAtClass;
function ExternalAsyncTaskRequest_createdAt() {
  if (ExternalAsyncTaskRequest_createdAtClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_createdAt_instance = this;
        var tmp = this;
        tmp.t34_1 = lazy(ExternalAsyncTaskRequest_createdAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u34_1 = lazy(ExternalAsyncTaskRequest_createdAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v34_1 = lazy(ExternalAsyncTaskRequest_createdAt$annotations$delegate$lambda);
        this.w34_1 = System_instance.d1m();
        this.x34_1 = 'Clock.System.now()';
      }
      k20() {
        var tmp0 = this.t34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_createdAt$_get_name_$ref_k7044e(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.e34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      s34(receiver, value) {
        return receiver.l34(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.s34(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_createdAt$_get_serializer_$ref_77uhmx(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_createdAt$_get_annotations_$ref_qrm3bn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_createdAt', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_createdAtClass = $;
  }
  return ExternalAsyncTaskRequest_createdAtClass;
}
var ExternalAsyncTaskRequest_createdAt_instance;
function ExternalAsyncTaskRequest_createdAt_getInstance() {
  if (ExternalAsyncTaskRequest_createdAt_instance === VOID)
    new (ExternalAsyncTaskRequest_createdAt())();
  return ExternalAsyncTaskRequest_createdAt_instance;
}
function ExternalAsyncTaskRequest_response$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function ExternalAsyncTaskRequest_response$_get_name_$ref_nxcth0() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_response$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_response$_get_serializer_$ref_urow2j() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_response$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function ExternalAsyncTaskRequest_response$_get_annotations_$ref_ohg2yn() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_responseClass;
function ExternalAsyncTaskRequest_response() {
  if (ExternalAsyncTaskRequest_responseClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_response_instance = this;
        var tmp = this;
        tmp.y34_1 = lazy(ExternalAsyncTaskRequest_response$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.z34_1 = lazy(ExternalAsyncTaskRequest_response$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.a35_1 = lazy(ExternalAsyncTaskRequest_response$annotations$delegate$lambda);
        this.b35_1 = null;
        this.c35_1 = 'null';
      }
      k20() {
        var tmp0 = this.y34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_response$_get_name_$ref_nxcth0(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.f34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      d35(receiver, value) {
        return receiver.l34(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.d35(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.z34_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_response$_get_serializer_$ref_urow2j(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.a35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_response$_get_annotations_$ref_ohg2yn(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_response', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_responseClass = $;
  }
  return ExternalAsyncTaskRequest_responseClass;
}
var ExternalAsyncTaskRequest_response_instance;
function ExternalAsyncTaskRequest_response_getInstance() {
  if (ExternalAsyncTaskRequest_response_instance === VOID)
    new (ExternalAsyncTaskRequest_response())();
  return ExternalAsyncTaskRequest_response_instance;
}
function ExternalAsyncTaskRequest_result$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function ExternalAsyncTaskRequest_result$_get_name_$ref_nreivk() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_result$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_result$_get_serializer_$ref_ennnsn() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_result$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function ExternalAsyncTaskRequest_result$_get_annotations_$ref_qqptnf() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_resultClass;
function ExternalAsyncTaskRequest_result() {
  if (ExternalAsyncTaskRequest_resultClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_result_instance = this;
        var tmp = this;
        tmp.e35_1 = lazy(ExternalAsyncTaskRequest_result$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f35_1 = lazy(ExternalAsyncTaskRequest_result$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g35_1 = lazy(ExternalAsyncTaskRequest_result$annotations$delegate$lambda);
        this.h35_1 = null;
        this.i35_1 = 'null';
      }
      k20() {
        var tmp0 = this.e35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_result$_get_name_$ref_nreivk(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.g34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      d35(receiver, value) {
        return receiver.l34(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.d35(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.f35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_result$_get_serializer_$ref_ennnsn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_result$_get_annotations_$ref_qqptnf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_result', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_resultClass = $;
  }
  return ExternalAsyncTaskRequest_resultClass;
}
var ExternalAsyncTaskRequest_result_instance;
function ExternalAsyncTaskRequest_result_getInstance() {
  if (ExternalAsyncTaskRequest_result_instance === VOID)
    new (ExternalAsyncTaskRequest_result())();
  return ExternalAsyncTaskRequest_result_instance;
}
function ExternalAsyncTaskRequest_action$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function ExternalAsyncTaskRequest_action$_get_name_$ref_iymt2v() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_action$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_action$_get_serializer_$ref_rxfcy8() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_action$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function ExternalAsyncTaskRequest_action$_get_annotations_$ref_2otkr0() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_actionClass;
function ExternalAsyncTaskRequest_action() {
  if (ExternalAsyncTaskRequest_actionClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_action_instance = this;
        var tmp = this;
        tmp.j35_1 = lazy(ExternalAsyncTaskRequest_action$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k35_1 = lazy(ExternalAsyncTaskRequest_action$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l35_1 = lazy(ExternalAsyncTaskRequest_action$annotations$delegate$lambda);
        this.m35_1 = null;
        this.n35_1 = 'null';
      }
      k20() {
        var tmp0 = this.j35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_action$_get_name_$ref_iymt2v(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.h34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      d35(receiver, value) {
        return receiver.l34(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.d35(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_action$_get_serializer_$ref_rxfcy8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_action$_get_annotations_$ref_2otkr0(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_action', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_actionClass = $;
  }
  return ExternalAsyncTaskRequest_actionClass;
}
var ExternalAsyncTaskRequest_action_instance;
function ExternalAsyncTaskRequest_action_getInstance() {
  if (ExternalAsyncTaskRequest_action_instance === VOID)
    new (ExternalAsyncTaskRequest_action())();
  return ExternalAsyncTaskRequest_action_instance;
}
function ExternalAsyncTaskRequest_lastAttempt$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function ExternalAsyncTaskRequest_lastAttempt$_get_name_$ref_86o6ym() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_lastAttempt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_lastAttempt$_get_serializer_$ref_mon9y3() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_lastAttempt$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function ExternalAsyncTaskRequest_lastAttempt$_get_annotations_$ref_n6s1x3() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_lastAttemptClass;
function ExternalAsyncTaskRequest_lastAttempt() {
  if (ExternalAsyncTaskRequest_lastAttemptClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_lastAttempt_instance = this;
        var tmp = this;
        tmp.o35_1 = lazy(ExternalAsyncTaskRequest_lastAttempt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p35_1 = lazy(ExternalAsyncTaskRequest_lastAttempt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q35_1 = lazy(ExternalAsyncTaskRequest_lastAttempt$annotations$delegate$lambda);
        this.r35_1 = Companion_getInstance_0().e1m_1;
        this.s35_1 = 'Instant.DISTANT_PAST';
      }
      k20() {
        var tmp0 = this.o35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_lastAttempt$_get_name_$ref_86o6ym(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.i34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      s34(receiver, value) {
        return receiver.l34(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.s34(tmp, value instanceof Instant() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.p35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_lastAttempt$_get_serializer_$ref_mon9y3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_lastAttempt$_get_annotations_$ref_n6s1x3(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_lastAttempt', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_lastAttemptClass = $;
  }
  return ExternalAsyncTaskRequest_lastAttemptClass;
}
var ExternalAsyncTaskRequest_lastAttempt_instance;
function ExternalAsyncTaskRequest_lastAttempt_getInstance() {
  if (ExternalAsyncTaskRequest_lastAttempt_instance === VOID)
    new (ExternalAsyncTaskRequest_lastAttempt())();
  return ExternalAsyncTaskRequest_lastAttempt_instance;
}
function ExternalAsyncTaskRequest_processingError$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(8);
}
function ExternalAsyncTaskRequest_processingError$_get_name_$ref_u6e7vg() {
  return (p0) => p0.k20();
}
function ExternalAsyncTaskRequest_processingError$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ExternalAsyncTaskRequest_processingError$_get_serializer_$ref_p19dod() {
  return (p0) => p0.j2j();
}
function ExternalAsyncTaskRequest_processingError$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(8);
}
function ExternalAsyncTaskRequest_processingError$_get_annotations_$ref_lcuw9l() {
  return (p0) => p0.bz();
}
var ExternalAsyncTaskRequest_processingErrorClass;
function ExternalAsyncTaskRequest_processingError() {
  if (ExternalAsyncTaskRequest_processingErrorClass === VOID) {
    class $ {
      constructor() {
        ExternalAsyncTaskRequest_processingError_instance = this;
        var tmp = this;
        tmp.t35_1 = lazy(ExternalAsyncTaskRequest_processingError$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u35_1 = lazy(ExternalAsyncTaskRequest_processingError$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v35_1 = lazy(ExternalAsyncTaskRequest_processingError$annotations$delegate$lambda);
        this.w35_1 = null;
        this.x35_1 = 'null';
      }
      k20() {
        var tmp0 = this.t35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ExternalAsyncTaskRequest_processingError$_get_name_$ref_u6e7vg(), null);
        return tmp0.f2();
      }
      a34(receiver) {
        return receiver.j34_1;
      }
      m2j(receiver) {
        return this.a34(receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE());
      }
      d35(receiver, value) {
        return receiver.l34(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof ExternalAsyncTaskRequest() ? receiver : THROW_CCE();
        return this.d35(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ExternalAsyncTaskRequest_processingError$_get_serializer_$ref_p19dod(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v35_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ExternalAsyncTaskRequest_processingError$_get_annotations_$ref_lcuw9l(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'ExternalAsyncTaskRequest_processingError', VOID, VOID, [SerializableProperty()]);
    ExternalAsyncTaskRequest_processingErrorClass = $;
  }
  return ExternalAsyncTaskRequest_processingErrorClass;
}
var ExternalAsyncTaskRequest_processingError_instance;
function ExternalAsyncTaskRequest_processingError_getInstance() {
  if (ExternalAsyncTaskRequest_processingError_instance === VOID)
    new (ExternalAsyncTaskRequest_processingError())();
  return ExternalAsyncTaskRequest_processingError_instance;
}
//region block: exports
export {
  prepareExternalAsyncTaskRequestFields as prepareExternalAsyncTaskRequestFieldshbi2ejghvwsa,
};
//endregion

//# sourceMappingURL=ExternalAsyncTaskRequestFields.mjs.map
